import Vue from 'vue';
import {
  AUTH_ERROR,
  AUTH_LOGOUT,
  AUTH_REFRESH,
  AUTH_REQUEST, AUTH_SET_TOKEN,
  AUTH_SUCCESS,
} from '@/store/actions/auth';
import { SERVER_MESSAGES_LOGOUT } from '@/store/actions/serverMessages';

const tokenProvider = {
  clearToken() {
    localStorage.removeItem('user-token');
  },
  getToken() {
    return localStorage.getItem('user-token') || '';
  },
  setToken(value) {
    localStorage.setItem('user-token', value);
  },
};

const initialState = {
  token: tokenProvider.getToken(),
  status: '',
  hasLoadedOnce: false,
};

const getters = {
  isAuthenticated: (state) => state.token !== '',
  token: (state) => state.token,
  hasLoadedOnce: (state) => state.hasLoadedOnce,
};

const actions = {
  [AUTH_REQUEST]: ({ commit }, user) => new Promise((resolve, reject) => {
    commit(AUTH_REQUEST);
    Vue
      .axios
      .post('/api/auth/login', user)
      .then((response) => {
        tokenProvider.setToken(response.data.token);
        commit(AUTH_SUCCESS, response.data.token);
        resolve(response.data);
      })
      .catch((err) => {
        commit(AUTH_ERROR, err);
        tokenProvider.clearToken();
        reject(err);
      });
  }),
  [AUTH_LOGOUT]: ({ commit, dispatch }) => new Promise((resolve) => {
    commit(AUTH_LOGOUT);
    tokenProvider.clearToken();
    dispatch(SERVER_MESSAGES_LOGOUT);
    resolve();
  }),
  [AUTH_REFRESH]: ({ commit }) => new Promise((resolve, reject) => {
    commit(AUTH_REQUEST);
    Vue
      .axios
      .post('/api/auth/refresh')
      .then((response) => {
        tokenProvider.setToken(response.data.token);
        commit(AUTH_SUCCESS, response.data.token);
        resolve(response.data);
      })
      .catch((err) => {
        commit(AUTH_ERROR, err);
        tokenProvider.clearToken();
        reject(err);
      });
  }),
  [AUTH_SET_TOKEN]: ({ commit }, token) => {
    commit(AUTH_SET_TOKEN, token);
  },
};

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [AUTH_SUCCESS]: (state, token) => {
    state.status = 'success';
    state.token = token;
    state.hasLoadedOnce = true;
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = '';
    state.hasLoadedOnce = false;
  },
  [AUTH_SET_TOKEN]: (state, token) => {
    tokenProvider.setToken(token);
    state.token = token;
  },
};

export default () => ({
  state: initialState,
  getters,
  actions,
  mutations,
});
